// types/enquiry.ts

export interface ContactDetail {
  id: string;
  contact_person_name: string;
  contact_person_email?: string;
  contact_person_phone_no?: string;
  contact_person_designation?: string;
  [key: string]: any; // in case API returns more fields
}

export interface Company {
  id: string;
  company_name: string;
  industry_name?: string;
  contact_details?: ContactDetail[];
  [key: string]: any;
}

export interface Agent {
  agent_name: string;
  agnet_designation?: string;
  agnet_department?: string;
  [key: string]: any;
}

export interface ItemDetail {
  item: string;
  item_name: string;
  category: string;
  sub_category: string;
  make: string;
  model: string;
  product_name: string;
  quantity: number;
  [key: string]: any;
  unit_price: "";
  total_amount?: "";
  total_price?: "";
  category_name: string;      // <-- ADDED
  sub_category_name: string;  // <-- ADDED
  make_name: string;          // <-- ADDED
  model_name: string;         // <-- ADDED
}

export interface AssignedMember {
  user: string;
  [key: string]: any;
}

export interface EnquiryInitialData {
  id: string;
  enquiry_date: string;
  received_date: string;
  initiated_by: string;
  reference: string;
  source_of_enquiry: string;
  company: Company;
  industry?: string;
  contact_name?: ContactDetail[];
  agent: Agent;
  designation?: string;
  department?: string;
  emd?: string;
  members: AssignedMember[];
  terms?: string;
  notes?: string;
  item_details: ItemDetail[];
  status?: string;
  [key: string]: any;
  file: any;
  contactPerson: ContactDetail;
  contactPersonArray?: ContactDetail[]
}

export const initialEnquiryData: EnquiryInitialData = {
  id: "",
  enquiry_date: "",
  received_date: "",
  initiated_by: "",
  reference: "",
  source_of_enquiry: "",
  company: {
    id: "",
    company_name: "",
    industry_name: "",
    contact_details: [],
  },
  industry: "",
  contact_name: [],
  agent: {
    agent_name: "",
    agent_designation: "",
    agent_department: "",
  },
  designation: "",
  department: "",
  emd: "",
  members: [],
  terms: "",
  notes: "",
  item_details: [],
  status: "",
  file: "",
  contactPerson: {
    id: "",
    contact_person_name: "",
    contact_person_email: "",
    contact_person_phone_no: "",
    contact_person_designation: "",
  },
  contactPersonArray: [],
};
